import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategorySection from "./components/CategorySection";
import ContentSections from "./components/ContentSections";
import FAQSection from "./components/FAQSection";
import ArticleCTA from "./components/ArticleCTA";
import Footer from "./components/Footer";
import { WebSiteSchema, OrganizationSchema, FAQSchema } from "@/components/base/SchemaOrg";
import { faqItems } from "@/mocks/categories";

export default function Home() {
  return (
    <main>
      <WebSiteSchema
        name="GTBuy Spreadsheet"
        description="GTBuy Spreadsheet is the ultimate order tracking and management system for GTBuy, Kakobuy, and Superbuy proxy shoppers. Track purchases in real time, monitor shipping, and automate your international shopping workflow."
        url="https://gtbuyspreadsheet.skin"
      />
      <OrganizationSchema
        name="GTBuy Spreadsheet"
        url="https://gtbuyspreadsheet.skin"
        description="Order tracking and management spreadsheet system for GTBuy, Kakobuy, and Superbuy international proxy shopping platforms."
      />
      <FAQSchema questions={faqItems} />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <ContentSections />
      <FAQSection />
      <ArticleCTA />
      <Footer />
    </main>
  );
}